export class fakeHttpRequest {
  public getResponseHeader(arg: string) {
    return [];
  }
}
